export default class Devotee {
  firstName: string;
  lastName: string;
  email: string;
  address1: string;
  address2: string;
  city: string;
  state: string = "Tamil Nadu";
  pincode: string;
  mobile: string = "+91";
  country: string = "India";
  pan: string;
  passport: string;

  constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/models/Devotee.ts